import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {RegisterDeviceComponent} from './register-device.component';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslatePipeModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [RegisterDeviceComponent],
    providers: [],
    exports: [RegisterDeviceComponent]
})

export class RegisterDeviceModule {

}
